/* tslint:disable */
/* eslint-disable */
/**
 * JET Charge Illuminate Web API
 * JET Charge Illuminate Web API
 *
 * The version of the OpenAPI document: 1.0.0
 * Contact: rd@jetcharge.com.au
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from "../runtime";
/**
 * Only provided for WebhookType==OfflineDeviceReport
 * @export
 * @interface OfflineDeviceReportMetadata
 */
export interface OfflineDeviceReportMetadata {
    /**
     * Report period
     * @type {string}
     * @memberof OfflineDeviceReportMetadata
     */
    period?: OfflineDeviceReportMetadataPeriodEnum;
}

/**
 * @export
 */
export const OfflineDeviceReportMetadataPeriodEnum = {
    Daily: "Daily",
    Weekly: "Weekly",
    Monthly: "Monthly",
    Quarterly: "Quarterly",
    Annually: "Annually",
} as const;
export type OfflineDeviceReportMetadataPeriodEnum =
    (typeof OfflineDeviceReportMetadataPeriodEnum)[keyof typeof OfflineDeviceReportMetadataPeriodEnum];

/**
 * Check if a given object implements the OfflineDeviceReportMetadata interface.
 */
export function instanceOfOfflineDeviceReportMetadata(
    value: object,
): value is OfflineDeviceReportMetadata {
    return true;
}

export function OfflineDeviceReportMetadataFromJSON(
    json: any,
): OfflineDeviceReportMetadata {
    return OfflineDeviceReportMetadataFromJSONTyped(json, false);
}

export function OfflineDeviceReportMetadataFromJSONTyped(
    json: any,
    ignoreDiscriminator: boolean,
): OfflineDeviceReportMetadata {
    if (json == null) {
        return json;
    }
    return {
        period: json["period"] == null ? undefined : json["period"],
    };
}

export function OfflineDeviceReportMetadataToJSON(
    value?: OfflineDeviceReportMetadata | null,
): any {
    if (value == null) {
        return value;
    }
    return {
        period: value["period"],
    };
}
